import React from 'react';

const KctPage = () => (
    <div className="kct__container">
      <div>
        <div className="kct__info">
          <div className="kct__info--typo">
            Easily get Key Change Tokens for your Electricity meters
          </div>
          <div className="kct__info--img"></div>
        </div>
        <div>
          <div className="kct__instructions">
            <div className="kct__typography__header">Follow the instructions below to get your Tokens</div>
            <ol className="kct__instructions--list">
              <li>Select your DISCO below</li>
              <li>Search for your meter number.</li>
              <li>Enter the token provided in the order it was given.</li>
            </ol>
            <div className="kct__support">
              <div className="kct__support--1">For other questions click the link below and select the customer support channel you prefer</div>
              <div className="kct__green"><a href="http://conversations.buypower.ng/">conversations.buypower.ng</a></div>
            </div>
          </div>
          <div className="kct__hide">
            Select your Disco to get your token
          </div>
          <div className="kct__disco--img">
            <a href="https://adroitsuite.com.ng/jedkeychange"><div className="kct__jedc--img"></div></a>
            <a href="http://ie-payments.com/apps/tariff-migration-token/"><div className="kct__ikedc--img"></div></a>
          </div>
        </div>
      </div>
    </div>
  );

export default KctPage;


// WEBPACK FOOTER //
// ./src/components/KctPage.js